import styled, { keyframes } from 'styled-components'
import { MEDIA } from 'src/utils/constants'
const { MOBILE_UP } = MEDIA

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  input:-internal-autofill-selected {
    background-color: #fff !important;
  }
  /* Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: #808080 #DFE9EB;
  }

  /* Chrome, Edge and Safari */
  *::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  *::-webkit-scrollbar-track {
    border-radius: 6px;
    background-color: #DFE9EB;
  }

  *::-webkit-scrollbar-track:hover {
    background-color: #B8C0C2;
  }

  *::-webkit-scrollbar-track:active {
    background-color: #B8C0C2;
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #808080;
  }

  *::-webkit-scrollbar-thumb:hover {
    background-color: #6A6A6A;
  }

  *::-webkit-scrollbar-thumb:active {
    background-color: #6A6A6A;
  }
`
export const ScrollWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 19px;
  max-height: calc(100vh - 342px);
  overflow-y: auto;
  padding: 5px 24px 0 24px;
`

export const InnerContainer = styled.div`
  max-width: 392px;
  margin: 0 auto;
`
export const EmailWrapper = styled.div`
  width: 100%;
`
export const Footer = styled.footer`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  margin-top: 24px;
  flex-direction: column;
  gap: 16px;

  @media screen and ${MOBILE_UP} {
    justify-content: center;
  }
`
export const SpinnerButtonText = styled.span`
`
export const Spinner = styled.div`
  width: 20px;
  height: 20px;
  vertical-align: text-bottom;
  border: .15em solid;
  border-right: .25em solid transparent;
  border-radius: 50%;
  animation: ${rotate} .5s linear infinite;
  color: #fff;
`
